(function($) {
    $.fn.textfill = function() {

        var css_attr = 'font-size';

        function convertUnits(size, unit) {
            var value = '';
            switch(unit){
                case 'pt':
                    value = size * 0.75;
                break;
                case 'mm':
                    value = size * 0.264583;
                break;
                default:
                    value = size;
                break;
            }
            return value;
        }

        function dataOrDefault(data, def) {
            return data || def;
        }

        function getCombinedChildHeight(els) {
            return $.map(els, function(e){
                return $(e).outerHeight(true);
            }).reduce(function(p, c){
                return p + c;
            }, 0);
        }

        return this.each(function(index, value) {
            var $el = $(value);
            var options = {
                max_size: parseInt(dataOrDefault($el.data('max-font-size'), 32)),
                min_size: parseInt(dataOrDefault($el.data('min-font-size'), 1)),
                unit_type: dataOrDefault($el.data('font-unit-type'), 'pt')
            };

            var $children = $el.children(':visible');
            var target_size = options.max_size || $children.css(css_attr);
            var target_height = $el.outerHeight(true);
            var target_width = $el.outerWidth(true);
            var inner_height;

            $(this).on('text-fill', function() {
                target_size = options.max_size;

                do {
                    $children.css(css_attr, target_size + options.unit_type);
                    inner_height = getCombinedChildHeight($children);
                    target_size = convertUnits(target_size - 0.1);
                } while (
                    (
                        $children.outerWidth(true) > target_width ||
                        inner_height > target_height
                    ) && target_size >= options.min_size
                );
            });
        });
    };
})(jQuery);
